// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"b9c77d74","160":"918dc4f9","208":"59e6ed0b","293":"5078c37e","453":"442517af","516":"b74fa8b8","519":"aa29d4f7","917":"3a0f87e6","946":"6e41f496"}[chunkId] + ".chunk.js";
};